import { Component, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'lib-ff-separator',
  styleUrls: ['./separator.component.scss'],
  templateUrl: './separator.component.html',
  imports: [],
})
export class SeparatorComponent extends FieldType {
  private readonly modalService = inject(ModalService);

  public openTooltip() {
    this.modalService
      .open({
        title: this.props.header !== undefined ? this.props.header : this.props.addText,
        message: this.props.headerTooltip,
      })
      .then(
        () => null,
        () => null,
      );
  }

  public close() {
    this.modalService.close();
  }
}
